import { createSlice } from "@reduxjs/toolkit";
import { getVendorListAll } from "../../reduxApi/admin/VendorReduxApi";
const vendorSlice = createSlice({
    name: 'vendor',
    initialState: {
        status: 'idel',
        isFiltered: false,
        vendor: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteVendorAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.vendor.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.vendor.splice(index, 1);
                }
            });
        },
        updateVendorAction: (state, action) => {
            const index = state.vendor.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.vendor.splice(index, 1, { vendors: action.payload })
            }
        },
        addVendorAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.vendor.unshift({ vendors: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getVendorListAll.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getVendorListAll.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("action.payload--->", action.payload);
                state.vendor = action.payload.data;
            })
    }
})
export const { deleteVendorAction, updateVendorAction, addVendorAction, setFilteredStatus } = vendorSlice.actions
export default vendorSlice.reducer